/**
 * Searchbar Module
 * @dependencies gsap > 3.0
 */

import { gsap } from 'gsap';

window.addEventListener('load', function() {

  // DOM Elements
  const searchModule = document.querySelector('.search-module');
  if ( ! searchModule )
    return;

  const searchDisplay = document.querySelector('.js-search-module-display');
  const searchToggle = searchModule.querySelectorAll('.js-search-module-open, .js-search-module-close, .js-search-module-backdrop');
  const searchBg = searchModule.querySelector('.js-search-module-bg');
  const searchBackdrop = searchModule.querySelector('.js-search-module-backdrop');
  const searchContent = searchModule.querySelector('.js-search-module-content');
  const searchClose = searchModule.querySelector('.js-search-module-close');
  const searchInput = searchModule.querySelector('input[type="search"]');
  const searchResults = searchModule.querySelector('.js-search-module-results');
  const searchResultsTitle = searchResults.querySelector('p');
  const searchResultsList = searchResults.querySelector('ul');
  const searchResultsSubmit = searchResults.querySelector('button');
  const searchResultsLoader =  searchResults.querySelector('.js-loader');
  const searchApiRoute = searchModule.dataset.apiRoute;
  let throttleSearch = 0;

  // Events
  let searchOpened = false;
  if (!searchToggle.length) return;

  const searchToggleEvent = () => {
    if (searchOpened) {
      // Closing Tween
      const tl = gsap.timeline({onComplete: function() {
        searchInput.value = ''
        searchResults.classList.add('hide');
      }});
      tl.to(searchBg, { duration: 0.5, scaleY: 0, ease: "power3.out" }, 'start');
      tl.to(searchContent, { duration: 0.5, y: -80, autoAlpha: 0, ease: "power3.out" }, 'start+=0');
      tl.to(searchBackdrop, { duration: 0.5, autoAlpha: 0 }, 'start+=0');
      tl.to(searchClose,  { duration: 0.4, autoAlpha: 0, ease: "power3.out" }, 'start+=0');
      tl.set(searchDisplay, { autoAlpha: 0 });
      searchOpened = false;
    } else {
      searchInput.value = ''
      // Opening Tween
      const tl = gsap.timeline({onComplete: function() {
        // When the opening is complete, toggle the focus on the inputsearchInput.focus();
        searchInput.focus()
      }});
      tl.set(searchDisplay, { autoAlpha: 1 }, 'start');
      tl.fromTo(searchBackdrop, { duration: 0.5, autoAlpha: 0 }, { autoAlpha: 1 }, 'start+=0');
      tl.fromTo(searchBg, { duration: 0.5, scaleY: 0, ease: "power3.out"  }, { scaleY: 1, ease: "power3.out"  }, 'start+=0');
      tl.fromTo(searchClose, { duration: 0.5, y: -80, autoAlpha: 0, ease: "power3.out"  }, { y: 0, autoAlpha: 1, ease: "power3.out"  }, 'start+=0.1');
      tl.fromTo(searchContent, { duration: 0.5, y: -80, autoAlpha: 0, ease: "power3.out"  }, { y: 0, autoAlpha: 1, ease: "power3.out"  }, 'start+=0.15');
      searchOpened = true;
    }

    document.body.classList.toggle('search-open', searchOpened)
  }

  searchToggle.forEach((el) => {
    el.addEventListener('click', (ev) => {
      ev.preventDefault();
      searchToggleEvent();
    })
  });

  searchInput.addEventListener('input', () => {
    const query = searchInput.value.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    //const query = searchInput.value;
    if (query.length < 3) {
      searchResults.classList.add('hide')
      return;
    }
    searchResultsList.classList.add('hide');
    searchResultsSubmit.classList.add('hide');
    searchResultsList.innerHTML = '';
    searchResultsTitle.textContent = '';
    searchResults.classList.remove('hide');
    searchResultsLoader.classList.add('is-loading');

    clearTimeout(throttleSearch);
    throttleSearch = setTimeout(async () => {
      const response = await fetch(`${searchApiRoute}${query}`);
      const result = await response.json();
      searchResultsList.innerHTML = '';
      searchResultsLoader.classList.remove('is-loading');
      if (result && typeof result.items === 'object') {
        const items = result.items;
        items.forEach((item) => {
          const li = document.createElement('li');
          const a = document.createElement('a');
          a.textContent = item.title;
          a.href = item.permalink;
          li.insertAdjacentElement('afterbegin', a);
          searchResultsList.insertAdjacentElement('beforeend', li);
        })
        searchResultsTitle.textContent = searchResultsTitle.dataset.suggestLabel;
        searchResultsList.classList.remove('hide');
        searchResultsSubmit.classList.remove('hide');
      } else {
        searchResultsTitle.textContent = searchResultsTitle.dataset.noResultsLabel;
      }
    }, 500)
  })

  window.addEventListener('keyup', (e) => {
    if ((e.key === 'Escape' || e.keyCode === 27) && searchOpened) {
      e.preventDefault();
      searchToggleEvent();
    }
  })
});
